"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("react");
var react_quill_new_1 = __importDefault(require("react-quill-new"));
require("react-quill-new/dist/quill.snow.css");
require("@styles/overrides/quill_override.scss");
var form_style = __importStar(require("./GameplayForm.module.scss"));
var button_styles = __importStar(require("@components/Buttons/Button.module.scss"));
var useClearOnTime_1 = __importDefault(require("@hooks/useClearOnTime"));
var useKeyEnter_1 = require("@hooks/useKeyEnter");
var uuid_1 = require("uuid");
var PressKeyHint_1 = __importDefault(require("@components/Hints/PressKeyHint"));
function GameplayForm(_a) {
    var formData = _a.formData, setFormData = _a.setFormData, handleFormSubmit = _a.handleFormSubmit, t = _a.t;
    var objectivesInputRef = (0, react_2.useRef)(null);
    var progressionInputRef = (0, react_2.useRef)(null);
    var _b = (0, react_1.useState)(""), submitMessage = _b[0], setSubmitMessage = _b[1];
    (0, useClearOnTime_1.default)({ setText: setSubmitMessage, text: submitMessage });
    (0, useKeyEnter_1.useKeyEnterWithInput)({
        func: function (e) { return addObjectives(e); },
        inputRef: objectivesInputRef,
    });
    (0, useKeyEnter_1.useKeyEnterWithInput)({
        func: function (e) { return addProgression(e); },
        inputRef: progressionInputRef,
    });
    function submitForm(e) {
        e.preventDefault();
        handleFormSubmit();
    }
    function addObjectives(value) {
        var newObjective = {
            id: (0, uuid_1.v4)(),
            name: value,
        };
        setFormData(function (prev) {
            return __assign(__assign({}, prev), { objectives: __spreadArray(__spreadArray([], prev.objectives, true), [newObjective], false) });
        });
    }
    function addProgression(value) {
        var newProgression = {
            id: (0, uuid_1.v4)(),
            name: value,
        };
        setFormData(function (prev) {
            return __assign(__assign({}, prev), { progressions: __spreadArray(__spreadArray([], prev.progressions, true), [newProgression], false) });
        });
    }
    function handleInputChange(value, key) {
        setFormData(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[key] = value, _a));
        });
    }
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("form", { className: form_style.gameplay_form, onSubmit: submitForm, children: [(0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "story", children: t.story }), (0, jsx_runtime_1.jsx)(react_quill_new_1.default, { id: "story", "data-testid": "test-story", value: formData.story, onChange: function (e) {
                                handleInputChange(e, "story");
                            } })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "objectives", children: t.objectives }), (0, jsx_runtime_1.jsx)(PressKeyHint_1.default, {}), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-objectives", type: "text", id: "objectives", name: "objectives", ref: objectivesInputRef })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "progression", children: t.progression }), (0, jsx_runtime_1.jsx)(PressKeyHint_1.default, {}), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-progression", type: "text", id: "progression", name: "progression", ref: progressionInputRef })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "difficulty", children: t.difficulty }), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-difficulty", type: "text", id: "difficulty", name: "difficulty", value: formData.difficulty, onChange: function (e) { return handleInputChange(e.target.value, "difficulty"); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "pacing", children: t.pacing }), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-pacing", type: "text", id: "pacing", name: "pacing", value: formData.pacing, onChange: function (e) { return handleInputChange(e.target.value, "pacing"); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "player-experience", children: t.player_experience }), (0, jsx_runtime_1.jsx)("input", { "data-testid": "test-player-experience", type: "text", id: "player-experience", name: "player-experience", value: formData.player_experience, onChange: function (e) {
                                return handleInputChange(e.target.value, "player_experience");
                            } })] }), submitMessage.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "".concat(form_style.form_group, " ").concat(form_style.error), children: submitMessage })) : null, (0, jsx_runtime_1.jsx)("div", { className: form_style.form_footer, children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: button_styles.create_btn, "data-testid": "test-submit-form", children: t.saveBtn }) })] }) }));
}
exports.default = GameplayForm;
